const validators = {
  /**
   * Validate a US zip code from string
   *
   * @param value The zip code to be validated.
   * @return {boolean}
   */
  isZipValid : (value) => {

    if (typeof value === 'undefined') {
      return false;
    }

    let pattern = new RegExp(/\d{5}/, 'i');
    let isValid = false;
    if (pattern.test(value)) {
      isValid = true;
    }

    return isValid;
  }
}

export default validators;
